import React, { FunctionComponent } from 'react'
import GatsbyImage from 'gatsby-image'
import { has } from 'lodash'
import { ContentfulRichTextGatsbyReference } from 'gatsby-source-contentful/rich-text'

import ConditionalLink from 'components/utils/conditional-link'

import { RTFBlockComponentProps, RTFBlockComponentExport } from '../../types'

import { contentfulRtfImage } from './index.module.scss'

export interface RTFContentfulRtfImageGraphQLResult
  extends ContentfulRichTextGatsbyReference {
  __typename: EF.RTFBlockTypename.ContentfulRtfImage
  image: EF.FluidImageNode
  url?: string
}

export interface ContentfulRtfImageProps extends RTFBlockComponentProps {
  image: EF.FluidImageNode
  url?: string
}

const ContentfulRtfImage: FunctionComponent<ContentfulRtfImageProps> = ({
  image: {
    fields: { asset },
  },
  url,
}) => {
  return (
    <div className={contentfulRtfImage}>
      <ConditionalLink link={url}>
        <GatsbyImage alt={asset.title} fluid={asset.fluid} />
      </ConditionalLink>
    </div>
  )
}

const componentExport: RTFBlockComponentExport = {
  component: ContentfulRtfImage,
  isValid: (props) => has(props, 'image.fields.asset.fluid'),
}

export default componentExport
